import React from "react";
import RegistrationForm from "src/components/forms/registration/RegistrationForm";
import SocialLogin from "src/components/social-login";
import { useTranslation } from "react-i18next";
import { useBreakpointIsLowerOrEqual } from "src/hooks/responsive";
import { DialogContent, DialogTitle, DialogDescription } from "src/components/ui/dialog";
import { Button } from "src/components/ui/button";
import Divider from "src/components/ui/divider";

interface SignUpPopupProps {
  setIsLogin: (value: boolean) => void;
  title?: string;
  description?: string;
}

const SignUpPopup: React.FC<SignUpPopupProps> = ({ title, description, setIsLogin }) => {
  const { t } = useTranslation();
  const isMobile = useBreakpointIsLowerOrEqual("sm");

  return (
    <DialogContent className="z-[1024]" overlayClassName="z-[1023]" hideClose={!isMobile}>
      <DialogTitle className="!text-xl !p-3 text-center">{title || t("Sign Up")}</DialogTitle>
      {description && <DialogDescription className="!text-sm px-3 py-1.5 text-center mb-0">{description}</DialogDescription>}
      <div className="flex items-center justify-center gap-2">
        <span className="text-muted-foreground text-sm">{t("Already have an account?")}</span>
        <Button variant="link" className="p-0 h-fit" onClick={() => setIsLogin(true)}>
          {t("Sign In")}
        </Button>
      </div>
      <DialogDescription className="sr-only" />
      <div className="flex-1 overflow-y-auto customScrollbar2 py-3 px-6 h-fit">
        <SocialLogin />
        <Divider className="my-2" text={t("common.or", "or") as string} />
        <RegistrationForm />
      </div>
    </DialogContent>
  );
};

export default SignUpPopup;
